import { apiGet, apiPatch } from './client';
import type { IndustrySector, IndustrySectorBatchRequest } from '../types/IndustrySector';

export function getIndustrySectors(): Promise<IndustrySector[]> { return apiGet<IndustrySector[]>('/api/industry-sectors'); }

export function saveBatchIndustrySectors(added: IndustrySector[], modified: IndustrySector[], deletedIds: number[]): Promise<IndustrySector[]> {
  return apiPatch<IndustrySectorBatchRequest, IndustrySector[]>('/api/industry-sectors/batch', { added, modified, deleted: deletedIds });
}
